import { CallableInput } from "Components/Shared";
import AccountSelect from "Components/Shared/AccountSelect";
import CallableDDITextArea from "Components/Shared/CallableDDITextArea";
import DateTimePicker from "Components/Shared/DateTimePicker";
import { Field, Formik } from "formik";
import { useAccount, useTicket } from "Hooks/Endpoints";
import React from "react";
import {
  Button,
  Container,
  Dimmer,
  Form,
  Icon,
  Loader,
  Menu,
  Segment,
} from "semantic-ui-react";
import * as yup from "yup";

const validation = yup.object().shape({
  customer: yup.object().required(),
  migrationNumbers: yup.string().required(),
  billStart: yup.string().required(),
});

type MigrateNumberFormProps = {
  onBack: Function;
};

const MigrateNumberForm = ({ onBack }: MigrateNumberFormProps) => {
  const { listAccounts } = useAccount();

  const { saveMigrationRequest, loading } = useTicket();

  const initValues = {};

  return (
    <Container textAlign='left'>
      <Dimmer active={loading} inverted>
        <Loader inverted />
      </Dimmer>
      <Menu fluid stackable>
        <Menu.Item header onClick={() => onBack()}>
          <Icon name='x' />
        </Menu.Item>
        <Menu.Item header>Number Migration Request</Menu.Item>
      </Menu>
      <Segment>
        <Formik
          initialValues={initValues}
          onSubmit={(values) => {
            saveMigrationRequest(values);
          }}
          validationSchema={validation}
          render={({ handleSubmit, isValid, errors }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <AccountSelect
                  accounts={listAccounts}
                  name='customer'
                  label='Select Account'
                />

                <Field
                  name='migrationNumbers'
                  label='Numbers to migrate'
                  component={CallableDDITextArea}
                />

                <DateTimePicker name='billStart' label='Bill Start' />

                <h2>Site Details </h2>

                <Field
                  name='address.line1'
                  label='Premises'
                  component={CallableInput}
                />

                <Field
                  name='address.line2'
                  label='Street'
                  component={CallableInput}
                />

                <Field
                  name='address.level2'
                  label='Town'
                  component={CallableInput}
                />

                <Field
                  name='address.level1'
                  label='Province'
                  component={CallableInput}
                />

                <Field
                  name='address.postalCode'
                  label='PostCode'
                  component={CallableInput}
                />

                <Field
                  name='address.country'
                  label='Country'
                  component={CallableInput}
                />
                {JSON.stringify(errors)}
                <Button primary disabled={!isValid}>
                  Submit
                </Button>
              </Form>
            );
          }}
        />
      </Segment>
    </Container>
  );
};

export default MigrateNumberForm;
